import React from "react"
import { Link } from "react-router-dom"

function MessageBanner({ messages, onClose }) {
  return (
    <div
      className="banner-2fa p-tag-warning"
      style={{
        backgroundColor: "var(--yellow-200)",
        padding: "9px 11px",
        position: "relative",
      }}
    >
      <button
        onClick={onClose}
        style={{
          position: "absolute",
          top: "0px",
          right: "10px",
          background: "transparent",
          border: "none",
          fontSize: "27px",
          cursor: "pointer",
          color: "#383838",
        }}
      >
        &times;
      </button>

      {messages.map((message, index) => (
        <p
          key={index}
          style={{
            fontSize: "15px",
            color: "#383838",
            fontFamily: "Lato, sans-serif",
            fontWeight: "700",
            textAlign: "center",
          }}
        >
          {message}{" "}
          {message.includes("Two Factor Authentication enabled") && (
            <Link
              to="/account/2fa/settings"
              style={{
                textDecoration: "underline",
              }}
            >
              Configure
            </Link>
          )}
        </p>
      ))}
    </div>
  )
}

export default MessageBanner
